import { render, staticRenderFns } from "./DashboardReferralBanner.vue?vue&type=template&id=0e42f420&"
import script from "./DashboardReferralBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardReferralBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports